import React from 'react';
import StatementTable from '../components/statments/StatementTable';
import { useSelector } from 'react-redux';

const StatementPage = () => {
    const activeCurrencyPage = useSelector(state => state.juno.activeCurrencyPage);
    return (
        <div className="bg-[#F4F4F5] dark:bg-[#18181B]">
            <StatementTable isDashboardPage={false} activeCurrencyPage={activeCurrencyPage} />
        </div>
    );
};

export default StatementPage;
